var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'customer-filters__wrapper d-flex flex-row align-items-center',
    `justify-content-${_vm.justifyContent}`,
  ]},[_c('CustomerDateFilter',{ref:"customerDateFilter",attrs:{"loading":_vm.dataLoading}}),(_vm.isOrgAdvancedUserOrAdmin)?_c('OwnerFilter'):_vm._e(),_c('CustomerStatusesFilter',{attrs:{"entity":"customers"}}),_c('CustomerFraudRatingFilter'),_c('CustomerTagsFilter'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }